<template>
    <div style="position:absolute;background:red;width:100%;height:100%;z-index:1;">
        <div
            style="position: sticky;top:0px; text-align:right;z-index: 100;background:white;border-bottom: 1px solid gray;">
            <span class="btn btn-default" @click="closeClicked">X</span>
        </div>
        <slot></slot>
    </div>
</template>
<script>
export default {
    props: {
        "show": Boolean
    },
    computed: {

    },
    data: function () {
        return {

        };
    },
    methods: {
        closeClicked: function () {
            this.$emit("onclose");
        }
    },
    created: function () {

    }
}
</script>